export default function experienceMarkerSelected(sm, experienceMarker){
    // No analytics here: EXPERIENCE_MARKER_SELECTED is sent by the submarker card's AnalyticsWatcher
    // when the card is shown, as on native. Sending it here too double-counted every web tap.
    // See plans/2026-09-23--double-counts-itinerary-items-and-map-markers.md.
    const mapFilter = sm.state['mapFilter'];
    const experience = experienceMarker.experience;
    if (mapFilter && experience) {
        experienceMarker.onlineApp.onlineAppRouter.navigateToFilterExperience(mapFilter, experience);
    }
}